/** Empty workspace ids mean every request. A selection keeps those incidents. */
export function filterRequestsByWorkspace<T extends { incidentId: string }>(
  requests: T[],
  workspaceIds: string[]
): T[] {
  if (workspaceIds.length === 0) return requests;
  const selected = new Set(workspaceIds);
  return requests.filter((request) => selected.has(request.incidentId));
}
